module.exports = __webpack_public_path__ + "img/invite-participant.687792a6.svg";